import { z } from "zod";
import { AwardReportSchema } from "./AwardReport";

export const AwardReportRequestSchema = AwardReportSchema.pick({
    description: true
});

export type AwardReportRequest = z.infer<typeof AwardReportRequestSchema>;
